import React, { useEffect } from "react";
import CalenderIcon from "../../../assets/images/calendar-icon.svg";
import styles from "../TicketProcessingView.module.scss";
import { DateFilterProps } from "..";
import { useFormContext } from "react-hook-form";
import { DateFormat } from "../../../enums/dateTimeFormat";
import { disableFutureDates } from "../../../utils/disabledDateUtil";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import { fieldNames, ticketProcessingConstants } from "../constants";
import moment from "moment";
import InputField from "../../../reusable-components/TNInputField";
import { useTicketProcessingFilterContext } from "../../../context/TicketProcessingFilterContext";

export interface RangePickerFilterProps {
    handleSetDateRange: ({startDate, endDate}: DateFilterProps) => void;
}

const RangePickerFilter = (props: RangePickerFilterProps) => {

    const { handleSetDateRange } = props;
    const { setValue } = useFormContext();
    const { processingFilters } = useTicketProcessingFilterContext();
    const suffixIcon = (
        <img
            src={CalenderIcon}
            className={styles.calendarIcon}
            alt={ticketProcessingConstants.FILTER_ICON_ALT}
        />
    );

    useEffect(() => {
        if(!!processingFilters?.startDate)
            setValue(fieldNames.DATE_RANGE, 
                [moment(processingFilters?.startDate, DateFormat.MM_DD_YYYY_SLASHED, true), 
                    moment(processingFilters?.endDate, DateFormat.MM_DD_YYYY_SLASHED, true)]);
        else
            setValue(fieldNames.DATE_RANGE, null);
    }, [processingFilters])

    return (
        <InputField
            type={InputfieldTypes.RANGE_PICKER}
            suffix={suffixIcon}
            disabledDates={disableFutureDates}
            name={fieldNames.DATE_RANGE}
            allowDateClear
            onRangePickerChange={(dates) => {
            if (!dates || dates.length === 0) {
                setValue(fieldNames.DATE_RANGE, null);
                handleSetDateRange({
                startDate: undefined,
                endDate: undefined,
                });
            } else {
                const start = dates[0].format(
                DateFormat.MM_DD_YYYY_SLASHED
                );
                const end = dates[1].format(
                DateFormat.MM_DD_YYYY_SLASHED
                );
                setValue(fieldNames.DATE_RANGE, [start, end]);
                handleSetDateRange({ startDate: start, endDate: end });
            }
            }}
        />)
    ;
}

export default RangePickerFilter;